const contentCarousels = document.querySelectorAll('.content-carousel.swiper-slider');

contentCarousels.forEach((contentCarousel) => {
    const swiper = new Swiper(contentCarousel, {
        effect: 'coverflow',
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
            rotate: 0,
            stretch: 30,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: false,
        },
        speed: 400,
        autoplay: false,
        navigation: {
            prevEl: contentCarousel.querySelector('.swiper-button-prev'),
            nextEl: contentCarousel.querySelector('.swiper-button-next'),
        },
    });
});
